<div class="flex-column ms-1">
    <!-- Exportar -->
    <ng-container>
        <div class="flex-column">
            <app-theme-card themeScope="cases">
                <mat-card-content>
                    <!-- Multi-select -->
                    <form [formGroup]="filterForm">
                        <div class="flex-column">
                            <!-- # ROW 1 -->
                            <div class="flex-row align-space-between-start">
                                <div class="flex-row align-space-between-start gap-0-5rem flex-70">
                                    <!-- [(value)]="this.categoriesSelected" -->
                                    <mat-select class="flex-35 subtitle-2 mts-2" [(value)]="this.categoriesSelected"
                                        [placeholder]="('modules.cases.evolutions.dialog.evolution-type' | exp:'':'Tipo de evolución')" multiple
                                        (selectionChange)="this.selectOption($event)">
                                        <mat-option *ngFor="let category of this.listEvolutionTypes"
                                            value="{{category.id}}">
                                            {{ category.description }}
                                        </mat-option>
                                    </mat-select>
                                    <span class="text-primary-darker subtitle-1 mts-2">
                                        Período: {{ getLabelDate() }}
                                    </span>
                                </div>
                                <!-- Export and Add evolution -->
                                <div class="flex-row align-end-start gap-0-5rem flex-20">
                                    <button mat-icon-button [matTooltip]="('modules.cases.evolutions.multi-select.category-select.tooltips.export' | exp:'':'Exportar a...')" [color]="'primary'"
                                        [matMenuTriggerFor]="menuExport" [disabled]="this.attentions?.length==0">
                                        <mat-icon>save_alt</mat-icon>
                                    </button>
                                    <button mat-icon-button [matTooltip]="('modules.cases.evolutions.multi-select.category-select.tooltips.add-evolution' | exp:'':'Agregar evolución al caso')"
                                        (click)="openCreateEvolution()" [color]="'primary' "[disabled]="(!this.case?.active || this.case.rejected)">
                                        <mat-icon>add_circle_outlined</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <!-- # ROW 2 -->
                            <div class="flex-row align-start-center gap-1rem">
                                <button mat-button [color]="'primary'" (click)="this.onClickFilter()">
                                    <mat-icon [matTooltip]="('modules.cases.evolutions.multi-select.category-select.tooltips.filter-evolutions' | exp:'':'Filtrar evoluciones')" [svgIcon]="'Filter-enabled-primary'">
                                    </mat-icon>
                                    {{ 'modules.cases.evolutions.filtrar' | exp:'':'Filtrar' }}
                                </button>
                                <span class="text-secondary txt" (click)="removeFilter()"
                                    style="white-space: nowrap; cursor: pointer; position: relative;">{{ 'modules.cases.evolutions.multi-select.category-select.remove-filters' | exp:'':'Limpiar filtros' }}</span>
                            </div>
                        </div>
                    </form>
                    <!-- Div to export with transition -->
                    <div *ngIf="showOptions" [@enterAnimation] class="flex-column">
                        <mat-divider></mat-divider>
                        <form *ngIf="exportForm" [formGroup]="exportForm" class="flex-column">
                            <div class="headline-3 mys-3 text-primary">
                                {{ 'modules.cases.evolutions.export.title' | exp:'':'Configuración de exportación' }}
                            </div>
                            <div class="flex-row align-space-evenly-center">
                                <div class="flex-column flex-45">
                                    <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.evolutions.export.header' | exp:'':'Encabezado' }}</span>
                                    <app-select-input [name]="this.LOGO" [form]="this.exportForm"
                                        [placeholder]="('modules.cases.evolutions.select' | exp:'':'Seleccionar')" [elements]="this.elementsLogo"
                                        [calculateId]="this.calculateIdlogo" [calculateName]="this.calculateNameLogo">
                                    </app-select-input>
                                </div>
                                <div class="flex-column flex-45">
                                    <span class="subtitle-3 text-primary-darker">{{ 'modules.cases.evolutions.salida' | exp:'':'Salida' }}</span>
                                    <app-select-input [name]="this.OUTPUT_TYPE" [form]="this.exportForm"
                                        [placeholder]="('modules.cases.evolutions.select' | exp:'':'Seleccionar')" [elements]="this.elementsOutput"
                                        [calculateId]="this.calculateIdOutput"
                                        [calculateName]="this.calculateNameOutput">
                                    </app-select-input>
                                </div>
                            </div>
                            <div *ngIf="this.logoForm == LOGO_OPTIONS.CUSTOM_LOGO">
                                <app-file-input class="flex-100" [name]="this.LOAD_FILE" [form]="this.exportForm">
                                </app-file-input>
                            </div>
                            <div *ngIf=" this.exportForm.errors && (this.exportForm.dirty || this.exportForm.touched)">
                                <mat-error *ngIf=" this.exportForm.errors &&
                            (this.exportForm.dirty || this.exportForm.touched)" class="flex-row align-start-center">
                                    <mat-icon class="text-warn mrs-2">error_outline</mat-icon>
                                    {{ objectValues(this.exportForm.errors)[0] }}
                                </mat-error>
                            </div>
                            <div class="flex-row align-space-evenly-center mbs-5" *ngIf="!!this.showVisibilityCheckbox">
                                <app-checkbox-input class="mt-3 subtitle-3 text-primary-darker" [form]="this.exportForm"
                                    [label]="('modules.cases.evolutions.export.labels.visible-financier' | exp:'':'Incluir ocultas al financiador')" [name]="this.VISIBLE_FINANCIER">
                                </app-checkbox-input>
                                <app-checkbox-input class="mt-3 subtitle-3 text-primary-darker" [form]="this.exportForm"
                                    [label]="('modules.cases.evolutions.export.labels.visible-provider' | exp:'':'Incluir ocultas al prestador')" [name]="this.VISIBLE_PROVIDER">
                                </app-checkbox-input>
                            </div>
                            <div class="flex-row align-space-around-start">
                                <button mat-stroked-button [color]="'primary'" (click)="this.showOptions = false">{{ ('common.cancel' | exp:'':'Cancelar')  }}</button>
                                <button mat-flat-button [color]="'primary'" (click)="this.onSubmitExportFunction()" [disabled]="(pdfSpinner$ | async) || exportForm.invalid">
                                    <span *ngIf="!(pdfSpinner$ | async)">{{ ('common.generate' | exp:'':'Generar')  }}</span>
                                    <mat-spinner *ngIf="(pdfSpinner$ | async)" color="accent" diameter="20"></mat-spinner>
                                </button>
                            </div>
                        </form>
                    </div>
                </mat-card-content>
            </app-theme-card>

            <mat-menu #menuExport="matMenu">
                <button mat-menu-item (click)="this.onClickOptionToExport(OPTIONS_TO_EXPORT.PDF)">
                    <mat-icon mat-list-icon [style.width.px]="30" [style.height.px]="30" [svgIcon]="'pdf'">
                    </mat-icon>{{ 'modules.cases.evolutions.export.formats.pdf' | exp:'':'PDF' }}
                </button>
                <button mat-menu-item (click)="this.onClickOptionToExport(OPTIONS_TO_EXPORT.ZIP)">
                    <mat-icon mat-list-icon [style.width.px]="30" [style.height.px]="30" [svgIcon]="'zip'">
                    </mat-icon>{{ 'modules.cases.evolutions.export.formats.zip' | exp:'':'ZIP' }}
                </button>
                <!-- TODO: not used yet -->
                <!-- <button mat-menu-item (click)="this.onClickOptionToExport(OPTIONS_TO_EXPORT.CSV)">
                    <mat-icon mat-list-icon [style.width.px]="30" [style.height.px]="30" [svgIcon]="'csv'">
                    </mat-icon>CSV
                </button> -->
            </mat-menu>
        </div>
    </ng-container>

    <ng-container *ngIf="!(this.isLoadingGettingEvolutions$ | async); else spinner">
        <!-- Evolutions -->
        <app-theme-card themeScope="cases" cardClass="mts-2">
            <ng-container *ngIf="this.attentions?.length > 0; else noEvolutions">
                <mat-card-content class="flex-row align-space-between-start flex">
                    <!-- Select dates -->
                    <div class="flex-column full-width">
                        <!-- Attentions list -->
                        <div id="{{(attention.id) ? attention.id : attention.evolutions[0].id}}"
                            class="flex-column autoAttention mb-4 anchor"
                            *ngFor="let attention of this.attentions; let i = index">
                            <div class="flex-row full-width">
                                <!-- Attention date & separator -->
                                <span class="text-primary-darker mb-2 autoAttentionDate">
                                    {{ (attention.id) ? ('modules.cases.evolutions.atencion' | exp:'':'Atencion') : (attention.evolutions[0].category) ?
                                    attention.evolutions[0].category.description : ('modules.cases.evolutions.evolution' | exp:'':'Evolución') }} {{ ('modules.cases.evolutions.del-dia' | exp:'':'Del dia') | lowercase }}
                                    {{ attention?.fromDate
                                    ? (attention.fromDate | date: 'dd/MM/yyyy' )
                                    : ('modules.cases.evolutions.no-data' | exp:'':'Sin datos') + ' - '
                                    }}
                                </span>
                                <!-- Practice -->
                                <span class="text-secondary ml-3 autoAttentionPractice" *ngIf="attention?.practice">
                                    {{attention?.practice?.name}}
                                </span>
                                <!-- Divider -->
                                <mat-divider class="mb-2" [inset]="true"></mat-divider>
                            </div>
                            <!-- Evolutions list -->
                            <div class="autoEvolution parentShowOnHover"
                                *ngFor="let evolution of filterDisplayEvolutions(attention.evolutions); let j = index; let last = last">
                                <div class="flex-row align-space-between-center full-width">
                                    <!-- Icon -->
                                    <div class="flex-7 align-end-start pl-1">
                                        <app-avatar
                                            [username]="!!evolution?.operator?.name ? evolution?.operator?.name : this.entitiesFacade.getProvidersFullName(evolution?.provider)"
                                            [tooltip]="!!evolution?.operator?.name ? evolution?.operator?.name : this.entitiesFacade.getProvidersFullName(evolution?.provider)"
                                            [size]="37" [textSizeRatio]="2" [initialsSize]="4">
                                        </app-avatar>
                                    </div>
                                    <!-- Data -->
                                    <div class="flex-column flex-90">
                                        <div class="flex-row align-space-between-start">
                                            <div class="flex-69">
                                                <h3 class="text-secondary-darker mb-0 pb-0 autoEvolutionName">
                                                    <ng-container
                                                        *ngIf="evolution.category.id==EVOLUTIONS_TYPE.ADMINISTRATIVE; else elseTemplate">
                                                        <span class="text-secondary">
                                                            {{!!evolution.operator && !!evolution.operator.name
                                                            ?
                                                            evolution.operator.name : (!!evolution.provider &&
                                                            !!this.entitiesFacade.getProvidersFullName(evolution.provider)
                                                            ?
                                                            this.entitiesFacade.getProvidersFullName(evolution.provider)
                                                            : (this.isModuleAttention(attention) ? ('modules.cases.evolutions.facturacion-modulo' | exp:'':'Facturación de módulo') : ('modules.cases.evolutions.sin-nombre' | exp:'':'Sin nombre')))}}
                                                        </span>
                                                    </ng-container>
                                                    <ng-template #elseTemplate>
                                                        {{
                                                        (attention.id) ?
                                                        (!!evolution.provider &&
                                                        !!this.entitiesFacade.getProvidersFullName(evolution.provider)
                                                        ?
                                                        this.entitiesFacade.getProvidersFullName(evolution.provider)
                                                        : (this.isModuleAttention(attention) ? ('modules.cases.evolutions.facturacion-modulo' | exp:'':'Facturación de módulo') : ('modules.cases.evolutions.sin-nombre' | exp:'':'Sin nombre') ) ) : '' }}
                                                    </ng-template>
                                                </h3>

                                                <!-- Inline media previews removed: use the right-side 'Ver adjunto' button to load attachments on demand -->

                                                <ng-container class="text-secondary-darker"
                                                    *ngIf="attention.id; else noAttentionIdType">
                                                    <span [ngSwitch]="evolution.category.id">
                                                        <span class="text-warn autoEvolutionType"
                                                            *ngSwitchCase="EVOLUTIONS_TYPE.ABSENT_PATIENT">
                                                            {{ 'modules.cases.evolutions.evolution-type.patient-absent' | exp:'':'Paciente ausente' }}
                                                        </span>
                                                        <span *ngSwitchCase="EVOLUTIONS_TYPE.NORMAL"
                                                            class="autoEvolutionType">
                                                            {{ 'modules.cases.evolutions.evolution-type.medical-evolution' | exp:'':'Evolución médica' }}
                                                        </span>
                                                        <span class="text-warn autoEvolutionType"
                                                            *ngSwitchCase="EVOLUTIONS_TYPE.NOT_GOING">
                                                            {{ 'modules.cases.evolutions.evolution-type.provider-absent' | exp:'':'Prestador ausente' }}
                                                        </span>
                                                        <span class="text-warn autoEvolutionType"
                                                            *ngSwitchCase="EVOLUTIONS_TYPE.CRITICAL">
                                                            {{ 'modules.cases.evolutions.evolution-type.critical-medical-evolution' | exp:'':'Evolución médica crítica' }}
                                                        </span>
                                                        <span class="text-primary-darker autoEvolutionType"
                                                            *ngSwitchCase="EVOLUTIONS_TYPE.DISCHARGE">
                                                            {{ 'modules.cases.evolutions.evolution-type.medical-discharge' | exp:'':'Alta médica' }}
                                                        </span>
                                                        <span class="autoEvolutionType"
                                                            *ngSwitchDefault>{{evolution?.category?.description}}
                                                        </span>
                                                    </span> —
                                                    <span
                                                        class="text-secondary mat-small multi_lines_text autoEvolutionText evText"
                                                        style="max-width: 200px!important;"
                                                        [innerHTML]="evolution.text | safeHtml">
                                                        <!-- {{ evolution.text }} -->
                                                    </span>
                                                </ng-container>
                                                <ng-template class="text-secondary-darker" #noAttentionIdType>
                                                    <span class="autoEvolutionType">
                                                        {{ evolution.category.description }}
                                                    </span>
                                                    <span
                                                        class="text-secondary mat-small multi_lines_text autoEvolutionText"
                                                        style="max-width: 200px!important;">
                                                        {{ evolution.text }}
                                                    </span>
                                                </ng-template>
                                            </div>
                                            <!-- Evolution number, menuButton and date -->
                                            <div class="flex-column text-secondary flex-30">
                                                <div class="flex-row align-space-between-none gap-gappx">
                                                    <span [matTooltip]="('modules.cases.evolutions.evolution-card.tooltips.evolution-code' | exp:'':'Código de evolución')"
                                                        class="text-primary-darker">E{{evolution.id}}
                                                    </span>
                                                    <mat-icon class="cursor-pointer text-secondary"
                                                        [matMenuTriggerFor]="menuEvolutions"
                                                        [matMenuTriggerData]="{ attention:attention, evolution:evolution }">more_vert
                                                    </mat-icon>
                                                </div>
                                                <span>
                                                    {{ evolution.date | date: 'dd/MM/yyyy HH:mm' }}
                                                </span>
                                                <!-- Right-side attachment link (loads media on demand) -->
                                                <div class="mts-2" *ngIf="shouldShowMediaLink(evolution)">
                                                    <span *ngIf="!isloadingGettingMedia || evolutionIdGettingMedia !== evolution?.id" class="evo-attachment-link text-primary-darker" (click)="downloadMedia(evolution)"><u>{{ 'modules.cases.evolutions.evolution-card.actions.view-attachment' | exp:'':'Ver adjunto' }}</u></span>
                                                    <div *ngIf="isloadingGettingMedia && evolutionIdGettingMedia === evolution?.id" class="custom-spinner"><mat-spinner diameter="20"></mat-spinner></div>
                                                </div>
                                            </div>
                                            <!-- Removed small inline PDF buttons: attachments load on demand via 'Ver adjunto' -->
                                        </div>
                                        <!-- AI review (MEDICA pipeline) -->
                                        <div class="ai-review-block mts-2" *ngIf="shouldShowAiReview(evolution)">
                                            <div class="flex-row align-space-between-center">
                                                <div class="flex-row align-start-center gap-0-5rem">
                                                    <span class="ai-review-title" *ngIf="evolution.aiStatus === 'ANALYZED'; else aiStatusPlain">
                                                        <mat-icon class="ai-review-title__icon" svgIcon="ai-review"
                                                            [style.width.px]="16" [style.height.px]="16"></mat-icon>
                                                        <span class="ai-review-title__text">{{ ('modules.cases.evolutions.ai-review.badge' | exp:'':'Revisión IA') }}</span>
                                                    </span>
                                                    <ng-template #aiStatusPlain>
                                                        <span class="ai-review-badge">{{ aiStatusLabel(evolution.aiStatus) }}</span>
                                                    </ng-template>
                                                    <button mat-button color="primary" class="ai-review-link" type="button"
                                                        *ngIf="evolution.aiStatus === 'ANALYZED'"
                                                        (click)="openRateDialog(evolution)">
                                                        {{ 'modules.cases.evolutions.ai-review.rate-evolution' | exp:'':'Calificar evolución' }}
                                                    </button>
                                                </div>
                                                <button mat-icon-button type="button" *ngIf="evolution.aiStatus === 'ANALYZED'"
                                                    (click)="toggleAiExpanded(evolution)"
                                                    [matTooltip]="('modules.cases.evolutions.ai-review.toggle-detail' | exp:'':'Ver detalle del análisis')">
                                                    <mat-icon>{{ isAiExpanded(evolution.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
                                                </button>
                                            </div>
                                            <app-evolution-ai-detail *ngIf="isAiExpanded(evolution.id) && getCachedAnalysis(evolution.id) as aiData"
                                                [analysis]="aiData"
                                                (rate)="openRateDialog(evolution)">
                                            </app-evolution-ai-detail>
                                            <div class="ai-auditor-mod mts-2" *ngIf="hasAuditorFeedback(evolution)">
                                                <mat-icon class="ai-auditor-mod__icon" svgIcon="ai-auditor-reply"
                                                    [style.width.px]="16" [style.height.px]="16"></mat-icon>
                                                <div class="ai-auditor-mod__body">
                                                    <div class="ai-auditor-mod__header">
                                                        <span class="ai-auditor-mod__name">{{ auditorDisplayName(evolution) }}</span>
                                                        <span class="ai-auditor-mod__sep"> - </span>
                                                        <span class="ai-auditor-mod__kind">{{ 'modules.cases.evolutions.ai-review.medical-modification' | exp:'':'Modificación evolución médica' }}</span>
                                                    </div>
                                                    <p class="ai-auditor-mod__notes" *ngIf="evolution.auditorNotes">{{ evolution.auditorNotes }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Visibility buttons -->
                                        <div class="flex-row align-start-center gap-1em">
                                            <button mat-button [disabled]="true"
                                                class="align-center-center autoVisibleFinancier" style="padding: 0px;">
                                                <mat-icon class="text-primary mat-icon-medium"
                                                    *ngIf="evolution.visibleFinancier">
                                                    visibility
                                                </mat-icon>
                                                <mat-icon class="text-secondary mat-icon-medium"
                                                    *ngIf="!evolution.visibleFinancier">
                                                    visibility_off
                                                </mat-icon>
                                                {{ this.case?.financier?.name || ('modules.cases.evolutions.labels.financier' | exp:'':'Financiador') }}
                                            </button>
                                            <button mat-button [disabled]="true"
                                                class="align-center-center autoVisibleProvider" style="padding: 0px">
                                                <mat-icon class="text-primary mat-icon-medium"
                                                    *ngIf="evolution.visibleProvider">
                                                    visibility
                                                </mat-icon>
                                                <mat-icon class="text-secondary mat-icon-medium"
                                                    *ngIf="!evolution.visibleProvider">
                                                    visibility_off
                                                </mat-icon>
                                                {{ 'modules.cases.evolutions.prestadores' | exp:'':'Prestadores' }}
                                            </button>
                                        </div>
                                        <mat-divider class="mys-2" *ngIf="!last"
                                            [inset]="true">
                                        </mat-divider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Right dates nav -->
                    <ng-container *ngIf="this.attentions?.length > 0;">
                        <div class="tableOfContentContainer flex-row align-center-start"
                            style="height: 80vh; overflow-y: auto; overflow-x: hidden;">
                            <div class="tableOfContent docs-toc-container">
                                    <div class="docs-toc-heading">{{ 'modules.cases.evolutions.fechas' | exp:'':'Fechas' }}</div>
                                <nav *ngFor="let attention of this.attentionsWithoutDayRepeat; let i = index">
                                    <a href="#" (click)="onClickNavigateToAttention($event, attention)"
                                        [ngClass]="{'active': this.fragment == (attention.id || attention.evolutions[0].id).toString()}"
                                        class="docs-level-h3 docs-link">
                                        {{ attention?.fromDate ? (attention.fromDate | date: 'dd/MM/yyyy' ) : 'Sin datos - '}}
                                    </a>
                                </nav>
                            </div>
                        </div>
                    </ng-container>
                </mat-card-content>
            </ng-container>
        </app-theme-card>
        <!-- Message doesn't exist evolutions -->
        <ng-template #noEvolutions>
            <div *ngIf="emptyAttentions" class="noEvolutions flex-row wrap align-center-center">
                <span class="text-secondary-darker" *ngIf="this.attentionsPreviousFilter?.length == 0">
                    {{ 'modules.cases.evolutions.empty-state.no-evolutions-yet' | exp:'':'Aún no se han cargado evoluciones' }}
                </span>
                <span class="text-secondary-darker" *ngIf="this.attentionsPreviousFilter?.length > 0">
                    {{ 'modules.cases.evolutions.empty-state.no-evolutions-for-selected' | exp:'':'Aún no se han cargado evoluciones para los' }} <span class="subtitle-2 text-primary-darker">{{ 'modules.cases.evolutions.empty-state.selected-items' | exp:'':'items seleccionados' }}</span>
                </span>
            </div>
            <div *ngIf="!emptyAttentions" class="noEvolutions flex-row wrap align-center-center">
                <span class="text-secondary-darker">
                    {{ 'modules.cases.evolutions.empty-state.filter-no-results' | exp:'':'El filtro ingresado no encontró evoluciones' }}
                </span>
            </div>
        </ng-template>

        <ng-template #noEvolutionsFiltered>
            <div class="noEvolutions flex-row wrap align-center-center">
                <span class="text-secondary-darker">
                    {{ 'modules.cases.evolutions.empty-state.filter-no-results' | exp:'':'El filtro ingresado no encontró evoluciones' }}
                </span>
            </div>
        </ng-template>
    </ng-container>
</div>

<mat-menu #menuEvolutions="matMenu">
    <ng-template matMenuContent let-attention="attention" let-evolution="evolution">
        <button mat-menu-item (click)="this.openDialogModifyEvolution(evolution,attention)">
            <mat-icon>policy</mat-icon>
            <span>{{ 'modules.cases.evolutions.gestionar' | exp:'':'Gestionar' }}</span>
        </button>
    </ng-template>
</mat-menu>


<ng-template #spinner>
    <div class="spinner-hover">
        <mat-spinner diameter="60"></mat-spinner>
    </div>
</ng-template>

<!-- Create/Add evolution -->
<ng-template #addEvolutionForCase>
    <div class="flex-column">
        <!-- <div class="flex-row flex-100 align-start-center">
            <div class="flex-row flex-30 align-start-center gap-20p">
                <div class="flex-20 mls-2">
                    <mat-icon [ngClass]="{'text-primary-darker': this.case.active,'text-secondary': !this.case.active}"
                        class="mat-icon-extraLarge">assignment</mat-icon>
                </div>
                <div class="flex-column">
                    <span class="mat-h2 mb-0 text-secondary-darker">
                        {{ this.case.id }}
                    </span>
                    <span class="text-secondary">
                        {{this.case.active ? 'Caso abierto' : 'Caso cerrado'}}
                    </span>
                </div>
            </div>
            <div class="flex-row flex-30 align-start-center">
                <div class="flex-20 mls-2">
                    <mat-icon [ngClass]="{'text-primary-darker': this.case.active,'text-secondary': !this.case.active}"
                        class="mat-icon-extraLarge">person_pin</mat-icon>
                </div>
                <div class="flex-column">
                    <span class="mat-h2 mb-0 text-secondary-darker">
                        {{ this.case.patient.surname }}, {{ this.case.patient.name }}
                    </span>
                    <span class="text-secondary">{{ this.case.patient.typeDocument ?
                        this.case.patient.typeDocument : 'DNI '}}
                        {{ this.case.patient.documentNumber ? this.case.patient.documentNumber : 'Sin datos'}}
                    </span>
                </div>
            </div>
        </div> -->
       <div>
        <div class="separator separator-center">
            <span class="mx-2 text-primary-darker">
                {{ 'modules.cases.evolutions.dialog.evolution-data' | exp:'':'Datos de la evolución' }}
            </span>
        </div>
       </div>
        <form  [formGroup]="evolutionForm">
        <div class="flex-row" style="gap: 5rem; padding-top: 3vh;">
               <div class="flex-column flex-50">
                <span class>{{ 'modules.cases.evolutions.dialog.evolution-type' | exp:'':'Tipo de evolución' }}</span>
                        <app-select-input [name]="this.EVOLUTION_TYPE" [form]="this.evolutionForm"
                            [placeholder]="('modules.cases.evolutions.dialog.evolution-type' | exp:'':'Tipo de evolución')" [elements]="this.listEvolutionTypes"
                            [calculateId]="this.calculateId" [calculateName]="this.calculateName"
                            (selected)="onSelectCategory($event)" id="EvolutionCreateDialogComponent_cmbCategories">
                        </app-select-input>
                    </div>
                    <div class="flex-50">
                        <span class="subtitle-2">{{ 'modules.cases.evolutions.dialog.evolution-visibility' | exp:'':'Visibilidad de la evolución' }}</span>
                        <div class="flex-row">
                            <mat-checkbox id="visibleFinancier" (change)="financierVisibility = !financierVisibility"
                                [checked]="this.financierVisibility">
                                {{this.case.financier.name}}
                            </mat-checkbox>
                            <mat-checkbox id="visibleProvider" (change)="providersVisibility = !providersVisibility"
                                [checked]="this.providersVisibility">
                                {{ 'modules.cases.evolutions.prestadores' | exp:'':'Prestadores' }}
                            </mat-checkbox>
                        </div>
                    </div>
        </div>
        <!-- <div class="flex-row align-start-center mts-2"> -->
            <div class="flex-100 flex-row wrap align-space-between-start gap-5p">
                <app-text-area-input class="flex-60" [clearable]="true" [form]="this.evolutionForm"
                    [name]="this.EVOLUTION_TEXT" [placeholder]="('modules.cases.evolutions.dialog.form.placeholders.evolution-text' | exp:'':'Ingrese el texto de la evolución')"
                    id="EvolutionCreateDialogComponent_txtArea" (change)="onChangeDescription($event)">
                </app-text-area-input>
                <div class="flex-35 flex-column wrap">
                    <ng-template #updateEvolution>
                        <span class="text-secondary-darker">
                            {{ 'modules.cases.evolutions.dialog.evolution-type' | exp:'':'Tipo de evolución' }}:
                        </span>
                        <span class="text-secondary">
                            {{ this.evolutionToUpdate.category.description }}
                        </span>
                    </ng-template>
                    <file-pond #myPond [options]="pondOptions" (oninit)="pondHandleInit()"
                        (onaddfile)="pondHandleAddFile($event)" (onremovefile)="pondHandleRemoveFile($event)"
                        (onaddfilestart)="pondHandleProcessFile($event)"
                        id="EvolutionCreateDialogComponent_fileSelector">
                    </file-pond>
                </div>
            </div>
                <div class="flex-column">
                    <app-checkbox-input class="flex-row addTask" [form]="this.evolutionForm" [label]="('modules.cases.evolutions.dialog.form.add-task' | exp:'':'Crear tarea')"
                    [labelPosition]="'before'" [name]="this.ADD_TASK">
                </app-checkbox-input>
              @if(isAddingTask){
                  <span class="subtitle-3 text-primary-darker-h3">
                      {{ 'modules.cases.evolutions.dialog.form.operator' | exp:'':'Operador' }} *
                  </span>
                  <app-operator-select [name]="this.OPERATOR" [form]="this.evolutionForm"
                      [placeholder]="('modules.cases.evolutions.dialog.form.placeholders.select-operator' | exp:'':'Seleccione un operador')" [elements]="this.operators"
                      [defaultValue]="" [calculateId]="this.calculateIdOperator"
                      [calculateName]="this.calculateNameOperator" [placeholderSearching]="('modules.cases.evolutions.buscar-operador' | exp:'':'Buscar operador')"ç
                      [placeholderNoValue]="('modules.cases.evolutions.dialog.form.placeholders.no-value' | exp:'':'Sin resultados')" [nameSearching]="this.OPERATOR_SEARCHING">
                  </app-operator-select>
              }
                    </div>

            </form>
        <!-- </div> -->
        <!-- <div class="flex-row wrap align-center-center gap-2em">
            <button mat-button (click)="financierVisibility = !financierVisibility" class="align-center-center"
                id="EvolutionCreateDialogComponent_btnFinancierVisibility">
                <mat-icon class="text-primary mat-icon-medium" *ngIf="this.financierVisibility">visibility</mat-icon>
                <mat-icon class="text-secondary mat-icon-medium" *ngIf="!this.financierVisibility">visibility_off
                </mat-icon>
                {{this.case.financier.name}}
            </button>
            <button mat-button (click)="providersVisibility = !providersVisibility"
                id="EvolutionCreateDialogComponent_btnProviderVisibility">
                <mat-icon class="text-primary mat-icon-medium" *ngIf="this.providersVisibility">visibility</mat-icon>
                <mat-icon class="text-secondary mat-icon-medium" *ngIf="!this.providersVisibility">visibility_off
                </mat-icon>
                Prestadores
            </button>
        </div> -->
        <div class="flex-row align-space-around-stretch mts-2">
            <button mat-stroked-button [color]="'primary'" [disabled]="this.loadingConfirm" (click)="onCancelClick()"
                id="EvolutionCreateDialogComponent_btnCancel">{{ ('common.cancel' | exp:'':'Cancelar')  }}</button>
            <button mat-flat-button [color]="'primary'"
                [disabled]="!this.evolutionForm.valid || this.loadingConfirm || this.loadingAddFile"
                (click)="onConfirmClick()" id="EvolutionCreateDialogComponent_btnConfirm">
                <span *ngIf="!this.loadingConfirm; else loadingConfirmIcon">
                    {{ ('common.confirm' | exp:'':'Confirmar')  }}
                </span>
                <ng-template #loadingConfirmIcon>
                    <mat-icon>
                        <mat-spinner color="accent" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </ng-template>
            </button>
        </div>
    </div>
</ng-template>
